import { Entry, EntryValueType, GetEntriesResponse, EntryContent, TableInvalidEntry } from '../modules/entries/types';
import { Table } from '../modules/tables/types';
import { CellState, RowState, SortOrders } from './types';

export const isInvalidValue = (value?: EntryValueType) => {
  return (
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && !value.length)
  );
};

export const isInvalidRow = (invalid: TableInvalidEntry) => {
  return !!(Object.keys(invalid).length);
};

export const getBaseCellState = (isCellInvalid: boolean, isRowInvalid: boolean) => {
  if (isCellInvalid) {
    return 'Error';
  }
  if (isRowInvalid) {
    return 'Disabled';
  }
  return 'Default';
};

export const getCellsBaseState = (
  content: EntryContent,
  invalid: TableInvalidEntry,
  isInvalid: boolean,
  table: Table,
) => {
  const fieldNames = table.keyOrder.length ? table.keyOrder : Object.keys(table.schema);
  const cellStates: CellState[] = [];
  fieldNames.forEach((fieldName) => {
    const invalidMessage = invalid?.[fieldName];
    cellStates.push({
      dataType: table.schema[fieldName].type,
      invalid: invalidMessage,
      state: getBaseCellState(!!invalidMessage, isInvalid),
      value: content?.[fieldName],
    });
  });
  return cellStates;
};

export const initTableState = (entries: GetEntriesResponse, table?: Table): RowState[] => {
  const tableState: RowState[] = [];
  if (!table) {
    return tableState;
  }

  entries.items.forEach((entry: Entry) => {
    const { content, invalid, ...other } = entry;
    const isInvalid = isInvalidRow(invalid);
    const cellStates = getCellsBaseState(content, invalid, isInvalid, table);
    tableState.push({ cellStates, isInvalid, entry: other });
  });
  return tableState;
};

export const getNextSortingOrder = (
  sortingKey?: string,
  order?: SortOrders,
  initialSortFieldName?: string,
): SortOrders | undefined => {
  if (initialSortFieldName === sortingKey) { // not the first click on the same icon
    switch (order) {
      case 'ASC':
        return 'DESC';
      case 'DESC':
        return undefined;
      case undefined:
        return 'ASC';
      default:
        return undefined;
    }
  }
  return 'ASC';
};

export const processFilters = (filters?: Record<string, string[]>): Record<string, string> => {
  if (!filters) {
    return {};
  }
  return Object.keys(filters).reduce(
    (prev, curr) => {
      const filterValue = filters[curr];
      return { ...prev, [curr]: filterValue.join(',') };
    }, {},
  );
};
